import React from 'react'
import type { InstructorSplit } from '@/types/instructorSplit'

interface InstructorSplitCardProps {
  split: InstructorSplit
  instructorName: string
  instructorEmail: string
  onEdit: (split: InstructorSplit) => void
  onRemove: (userId: string) => void
  isRemoving?: boolean
}

export const InstructorSplitCard: React.FC<InstructorSplitCardProps> = ({
  split,
  instructorName,
  instructorEmail,
  onEdit,
  onRemove,
  isRemoving = false,
}) => {
  return (
    <div className="flex items-center gap-4 p-4 rounded-lg bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/5 hover:border-primary/30 transition-all">
      {/* Avatar */}
      <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
        <span className="material-symbols-outlined text-primary">person</span>
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0">
        <h4 className="font-medium text-gray-900 dark:text-white truncate">{instructorName || instructorEmail}</h4>
        {instructorName && <p className="text-xs text-gray-500 dark:text-text-muted truncate">{instructorEmail}</p>}
        <div className="flex items-center gap-3 mt-1 text-xs text-gray-500 dark:text-text-muted">
          {split.fixedAmount > 0 ? (
            <span className="text-primary font-medium">Rp {split.fixedAmount.toLocaleString('id-ID')} fixed</span>
          ) : (
            <span className="text-primary font-medium">{split.percentage}% split</span>
          )}
          <span className="text-gray-500">•</span>
          <span className="flex items-center gap-1">
            <span className="material-symbols-outlined text-sm">folder</span>
            {split.moduleAssignments?.length || 0} module(s) assigned
          </span>
        </div>
      </div>

      {/* Actions */}
      <div className="flex items-center gap-1">
        <button
          onClick={() => onEdit(split)}
          disabled={isRemoving}
          className="p-2 hover:bg-gray-200 dark:hover:bg-white/10 rounded-lg transition-colors disabled:opacity-50"
          title="Edit split"
        >
          <span className="material-symbols-outlined text-gray-500 dark:text-text-muted text-xl">edit</span>
        </button>
        <button
          onClick={() => onRemove(split.instructorId)}
          disabled={isRemoving}
          className="p-2 hover:bg-red-500/20 rounded-lg transition-colors disabled:opacity-50"
          title="Remove instructor"
        >
          {isRemoving ? (
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-red-400"></div>
          ) : (
            <span className="material-symbols-outlined text-red-400 text-xl">delete</span>
          )}
        </button>
      </div>
    </div>
  )
}

export default InstructorSplitCard
